(() => {
  'use strict';

  const popup = document.getElementById('cvGrowthPlanPopup');
  if (!popup) return;

  const pageType = popup.dataset.pageType;
  const query = new URLSearchParams(window.location.search);
  const sessionKey = 'cv_growth_plan_3_gifts_popup_shown_v1';
  const pendingCardRedeemSessionKey = 'cv_pending_card_redeem';
  const isSpinAuthReturn = query.get('open_spin') === '1';
  const isFormSuccessReturn = query.get('growth_form_success') === '1';
  const redeemCodeFromQuery = pageType === 'card_collection' ? (query.get('redeem') || '') : '';
  let pendingCardRedeemCode = '';
  try {
    if (redeemCodeFromQuery) {
      window.sessionStorage.setItem(pendingCardRedeemSessionKey, redeemCodeFromQuery);
    }
    pendingCardRedeemCode = window.sessionStorage.getItem(pendingCardRedeemSessionKey) || '';
  } catch (error) {
    pendingCardRedeemCode = '';
  }
  const hasRedeemCode = pageType === 'card_collection' && Boolean(redeemCodeFromQuery || pendingCardRedeemCode);
  const cardRedemptionPopupDelay = 3000;
  let opened = false;
  let cardPopupTimer = null;
  let bodyOverflowBeforeOpen = '';
  let floatingLayerObserver = null;
  let floatingLayerScanFrame = null;
  const hiddenRightFloatingElements = [];

  function hideRightFloatingLaunchers() {
    if (!opened) return;

    document.body.querySelectorAll('*').forEach((element) => {
      if (!(element instanceof HTMLElement) || popup.contains(element)) return;
      if (element.dataset.cvGrowthFloatingHidden === '1') return;

      const styles = window.getComputedStyle(element);
      if (styles.position !== 'fixed' || styles.visibility === 'hidden' || styles.display === 'none') return;

      const layer = Number.parseInt(styles.zIndex, 10);
      const rect = element.getBoundingClientRect();
      const isSmallLauncher = rect.width > 0 && rect.height > 0 && rect.width <= 220 && rect.height <= 220;
      const touchesRightEdge = rect.right >= window.innerWidth - 40 && rect.left >= window.innerWidth / 2;

      if (!isSmallLauncher || !touchesRightEdge || !Number.isFinite(layer) || layer < 1000) return;

      hiddenRightFloatingElements.push({
        element,
        visibility: element.style.getPropertyValue('visibility'),
        priority: element.style.getPropertyPriority('visibility'),
      });
      element.dataset.cvGrowthFloatingHidden = '1';
      element.style.setProperty('visibility', 'hidden', 'important');
    });
  }

  function queueRightFloatingLauncherScan() {
    if (floatingLayerScanFrame !== null) return;
    floatingLayerScanFrame = window.requestAnimationFrame(() => {
      floatingLayerScanFrame = null;
      hideRightFloatingLaunchers();
    });
  }

  function startFloatingLayerGuard() {
    hideRightFloatingLaunchers();
    floatingLayerObserver = new MutationObserver(queueRightFloatingLauncherScan);
    floatingLayerObserver.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', queueRightFloatingLauncherScan);
  }

  function stopFloatingLayerGuard() {
    floatingLayerObserver?.disconnect();
    floatingLayerObserver = null;
    window.removeEventListener('resize', queueRightFloatingLauncherScan);

    if (floatingLayerScanFrame !== null) {
      window.cancelAnimationFrame(floatingLayerScanFrame);
      floatingLayerScanFrame = null;
    }

    hiddenRightFloatingElements.splice(0).forEach(({ element, visibility, priority }) => {
      if (!element.isConnected) return;
      delete element.dataset.cvGrowthFloatingHidden;
      if (visibility) {
        element.style.setProperty('visibility', visibility, priority);
      } else {
        element.style.removeProperty('visibility');
      }
    });
  }

  function hasShownInThisSession() {
    try {
      return window.sessionStorage.getItem(sessionKey) === '1';
    } catch (error) {
      return false;
    }
  }

  function markShownInThisSession() {
    try {
      window.sessionStorage.setItem(sessionKey, '1');
    } catch (error) {
      // The popup can still work when browser storage is unavailable.
    }
  }

  function openPopup() {
    if (opened || isSpinAuthReturn || hasShownInThisSession()) return;
    opened = true;
    markShownInThisSession();
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cv-growth-popup-open');
    bodyOverflowBeforeOpen = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    startFloatingLayerGuard();
    document.dispatchEvent(new CustomEvent('cv:growth-plan-popup:opened'));

    if (isFormSuccessReturn) {
      query.delete('growth_form_success');
      const cleanSearch = query.toString();
      const cleanUrl = `${window.location.pathname}${cleanSearch ? `?${cleanSearch}` : ''}${window.location.hash}`;
      window.history.replaceState({}, '', cleanUrl);
    }
  }

  function schedulePopupAfterCardRedemption() {
    if (cardPopupTimer || opened || hasShownInThisSession()) return;
    cardPopupTimer = window.setTimeout(() => {
      cardPopupTimer = null;
      openPopup();
    }, cardRedemptionPopupDelay);
  }

  document.addEventListener('cv:card-collection:redeemed', schedulePopupAfterCardRedemption);

  function closePopup() {
    if (!opened) return;
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cv-growth-popup-open');
    document.body.style.overflow = bodyOverflowBeforeOpen;
    stopFloatingLayerGuard();
    document.dispatchEvent(new CustomEvent('cv:growth-plan-popup:closed'));
  }

  popup.querySelectorAll('[data-cv-growth-close]').forEach((element) => {
    element.addEventListener('click', closePopup);
  });

  popup.querySelector('[data-cv-growth-cta]')?.addEventListener('click', (event) => {
    if (!document.getElementById('cvGrowthPlanBundle')) return;
    event.preventDefault();
    closePopup();
    window.setTimeout(() => {
      document.dispatchEvent(new CustomEvent('cv:growth-plan-bundle:open'));
    }, 150);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePopup();
  });

  function isFormsSuccessNode(node) {
    if (!(node instanceof Element)) return false;
    const text = String(node.textContent || '').toLowerCase();
    const successText = /thank|thanks|success|submitted|terima kasih|berhasil/.test(text);
    const successSelector = node.matches?.('[data-success], [class*="success"], [id*="success"]') ||
      node.querySelector?.('[data-success], [class*="success"], [id*="success"]');
    return Boolean(successText && successSelector);
  }

  function watchShopifyFormsSuccess() {
    const observer = new MutationObserver((mutations) => {
      const succeeded = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some(isFormsSuccessNode)
      );
      if (succeeded) {
        observer.disconnect();
        openPopup();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (isSpinAuthReturn) return;
    if (hasShownInThisSession()) return;

    if (pageType === 'card_collection') {
      if (hasRedeemCode) return;

      if (isFormSuccessReturn) {
        openPopup();
      } else if (popup.dataset.customerId) {
        openPopup();
      } else {
        watchShopifyFormsSuccess();
      }
      return;
    }

    openPopup();
  });
})();
